import React, { useEffect, useRef } from "react";
import { Row, Col, Input } from "reactstrap";

const CodeInput = ({ code = "", onChange }) => {
  const inputRefs = useRef([]);

  useEffect(() => {
    const firstEmptyIndex = code.split("").findIndex((c) => c === "");
    if (firstEmptyIndex !== -1 && inputRefs.current[firstEmptyIndex]) {
      inputRefs.current[firstEmptyIndex].focus();
    }
  }, [code]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    if (/^[0-9]?$/.test(value)) {
      const codeArray = code.split("");
      codeArray[index] = value;
      onChange(codeArray.join(""));

      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const codeArray = code.split("");

      if (codeArray[index] === "") {
        if (index > 0) {
          inputRefs.current[index - 1]?.focus();
        }
      } else {
        codeArray[index] = "";
        onChange(codeArray.join(""));
      }
    }
  };

  return (
    <Row className="my-2 px-2 justify-content-center">
      {[...Array(6)].map((_, index) => (
        <Col
          key={index}
          xs="2"
          className="px-1 mb-2 d-flex justify-content-center"
        >
          <Input
            type="text"
            maxLength="1"
            value={code[index] || ""}
            className="text-center fw-bold fs-4 border-primary rounded shadow-sm"
            onChange={(e) => handleInputChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            innerRef={(ref) => (inputRefs.current[index] = ref)}
            style={{
              height: "60px",
              width: "100%",
              minWidth: "45px",
            }}
          />
        </Col>
      ))}
    </Row>
  );
};

export default CodeInput;
